export default {
  header: {
    back: {
      url: 'http://chaumet.cn',
      content: '返回Chaumet.cn'
    }
  },
  playerCover: {
    title: 'CHAUMET寰宇艺境珍宝艺术展',
    content: '2018年6月28日（周四）- 9月17日（周日）',
    idYt: 'aXMgQ6xpdPg',
    cover: 'home/player/cover.jpg',
    legend: 'Video'
  },
  scrollCta: '滚动查看更多',
  worldDiscover: {
    title: {
      firstPart: '探索',
      secondPart: 'CHAUMET寰宇艺境珍宝艺术展'
    },
    content:
      '法国殿堂级珠宝时计世家尚美巴黎CHAUMET将于日本东京三菱一号馆美术馆揭幕“CHAUMET寰宇艺境珍宝艺术展”，一场探索CHAUMET历史文化、法式型格、艺术风潮及高级珠宝工艺的全新东方之旅即将开启。',
    worlds: {
      types: [
        {
          title: '约瑟芬（Josephine） 加冕•爱系列',
          content: 'CHAUMET的“缪斯女神”',
          img: 'home/world/josephine.jpg',
          url: 'josephine'
        },
        {
          title: 'CHAUMET',
          content: '首家珠宝店，位于芳登广场12号',
          img: 'home/world/chaumet.jpg',
          url: 'maison'
        },
        {
          title: 'CHAUMET与东瀛文化的渊源',
          content: '旅行邀请。',
          img: 'home/world/japon.jpg',
          url: 'japan'
        },
        {
          title: '自然主义',
          content: '源源不竭的灵感源泉。',
          img: 'home/world/nature.jpg',
          url: 'nature'
        },
        {
          title: '冠冕艺术',
          content: '设计优先。',
          img: 'home/world/art.jpg',
          url: 'tiara'
        },
        {
          title: '王者之选',
          content: '拿破仑一世皇帝赠送给教皇庇护七世的冠冕，权力的象征',
          img: 'home/world/pape.jpg',
          url: 'sovereigns'
        },
        {
          title: '情感艺匠',
          content: '可转换珠宝的艺术',
          img: 'home/world/sentimental.jpg',
          url: 'sentimental'
        },
        {
          title: '颂扬幸福美好的特殊瞬间',
          content: '精湛技艺',
          img: 'home/world/transformer.jpg',
          url: 'transformer'
        }
      ],
      cta: '探索'
    },
    legend: 'CHAUMET寰宇艺境珍宝艺术展'
  },
  wall: {
    title: 'CHAUMET寰宇艺境',
    content:
      '“CHAUMET寰宇艺境珍宝艺术展”诠释了自十九世纪下半叶起，CHAUMET放眼世界、吸收多元文化影响的发展历程。其间浩如烟海的珍宝艺作，是以CHAUMET代表的巴黎珠宝艺术对于世界文明的回响，这种精神亦使CHAUMET成为世界珠宝艺术舞台上的耀目主角。借由本次展览，CHAUMET表达了对于和风文化及东瀛匠心的崇高敬意。自十八世纪下叶以来，二者就建立了牢固的联系。从旧政权时代至今（期间包括“美好时代”时期的日本主义运动），法日艺术的碰撞见证了两国文化的辉煌。',
    previous: '向上',
    next: '向下',
    cta: 'see more',
    legend: '#TheWorldsOfChaumet'
  },
  footer: {
    title: '展览信息',
    exposition: {
      title: 'CHAUMET寰宇艺境珍宝艺术展',
      content: '2018年6月28日（周四）-9月17日（周日）日本东京三菱一号馆美术馆'
    },
    museum: {
      link: {
        title: '进入展厅',
        url: 'https://mimt.jp/chaumet/'
      },
      logo: 'home/museum-logo.png'
    },
    legend: '展览信息',
    links: [
      { logo: 'social/fb.png', url: 'https://www.facebook.com/Chaumet' },
      {
        logo: 'social/insta.png',
        url: 'https://www.instagram.com/chaumetofficial/'
      },
      { logo: 'social/yt.png', url: 'https://youtube.com/user/Chaumet' },
      { logo: 'social/gplus.png', url: 'https://plus.google.com/+chaumet' },
      { logo: 'social/pint.png', url: 'https://www.pinterest.fr/chaumet/' },
      { logo: 'social/twitter.png', url: 'https://twitter.com/Chaumet' },
      {
        logo: 'social/line.png',
        url: 'https://line.me/R/ti/p/%40chaumetofficial'
      },
      { logo: 'social/wechat.png' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/cn/home.js